import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Group from '@bubble-ui/primitive-group';
import Defs from '@bubble-ui/primitive-defs';
import ClipPath from '@bubble-ui/primitive-clip-path';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var PaymentLogoPrzelewy24 = _ref => {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoPrzelewy24',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    clipPath: "url(#clip0_4963_1203)"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#E13134",
    d: "M0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#CFD4DA",
    d: "M17.171 14.45a70.82 70.82 0 0 0 .245-1.46c0-.017-.483-.024-1.734-.024h-1.736l.09-.538c.086-.507.094-.54.15-.601.034-.036.405-.431.822-.882.419-.448 1.284-1.38 1.925-2.067l1.164-1.253h1.279L19.02 9.78l-.36 2.15.492.007.492.004-.013.1c-.014.114-.134.807-.15.88l-.011.046h-.492c-.27 0-.492.005-.492.01 0 .018-.23 1.415-.243 1.473l-.009.046h-1.072l.01-.046Zm.666-3.955a37.06 37.06 0 0 0 .227-1.445c-.009 0-.034.023-.055.05-.02.027-.607.656-1.303 1.397-.695.742-1.284 1.37-1.307 1.397l-.041.046h2.236l.243-1.445ZM8.243 14.46c0-.021.023-.174.052-.338.226-1.306.235-1.352.297-1.543.136-.421.394-.788.706-1 .287-.196.781-.37 1.814-.636.65-.17 1.284-.345 1.424-.398.293-.11.43-.245.503-.488.042-.138.168-.953.168-1.079a.384.384 0 0 0-.153-.282c-.101-.063-.4-.099-1.048-.13-.758-.036-1.233.012-1.501.149-.187.094-.327.469-.426 1.141l-.025.168-.54.006c-.346.002-.538-.002-.538-.017 0-.069.134-.777.178-.942.245-.918.693-1.31 1.665-1.456.456-.07 1.5-.094 1.996-.05.28.025.57.092.748.171.247.111.467.325.592.58.065.133.067.143.074.472a4.381 4.381 0 0 1-.22 1.56c-.145.432-.312.679-.587.863-.333.222-.526.293-1.66.603-1.664.453-1.766.488-1.946.629-.137.109-.204.266-.266.626l-.06.343-.01.057h2.03c1.118 0 2.032.006 2.032.013 0 .016-.145.884-.16.957l-.012.056h-2.564c-2.427 0-2.563-.002-2.563-.035Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M2.357 14.476c0-.01.155-.96.346-2.11.19-1.15.442-2.66.555-3.358.115-.698.215-1.292.222-1.324l.012-.059h1.605c1.281 0 1.658.007 1.868.032.762.09 1.12.316 1.265.802.063.218.063.381-.006.863-.12.827-.212 1.322-.283 1.525a1.669 1.669 0 0 1-.381.605.95.95 0 0 1-.367.264c-.205.096-.34.138-.63.199-.153.031-.331.036-1.452.036H3.834l-.097.576c-.052.316-.146.89-.21 1.27l-.112.698h-.528c-.306 0-.53-.008-.53-.018Zm4-3.573a1.63 1.63 0 0 0 .285-.073.625.625 0 0 0 .252-.237c.052-.1.28-1.325.28-1.503 0-.22-.07-.32-.266-.37-.13-.033-1.093-.064-2.031-.066l-.484-.002-.013.058a342.621 342.621 0 0 1-.362 2.166l-.01.059h1.074c.867 0 1.114-.007 1.276-.032Z"
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_4963_1203"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  }))));
};
PaymentLogoPrzelewy24.displayName = 'PaymentLogoPrzelewy24';
export default withProvisionalOverrideFromContext(PaymentLogoPrzelewy24);
//# sourceMappingURL=index.js.map